import { BlockStack, Text } from '@shopify/polaris';
import { StyledImageContainer, StyledWelcomeStep } from './styled';

const WelcomeStep = () => {
  return (
    <StyledWelcomeStep>
      <BlockStack gap="400">
        <Text as="p" variant="bodyLg" alignment="center" tone="subdued" fontWeight="medium">
          WELCOME TO SYNCTRACK ORDER TRACKING
        </Text>
        <Text as="h1" variant="headingXl" alignment="center">
          Branded tracking page → Real-time fulfillment insights
        </Text>
      </BlockStack>
      <StyledImageContainer>
        <img
          src={`https://media.synctrack.io/megamind-ordertracking/asset/onboarding_welcome.png`}
          alt="Synctrack branded tracking page and fulfillment dashboard"
          style={{ width: '100%', maxWidth: 704, borderRadius: 12 }}
        />
      </StyledImageContainer>
    </StyledWelcomeStep>
  );
};

export default WelcomeStep;
